<div class="card full-height">
  <div class="card-header">
    <span class="card-title">RSF Settings</span>
    <button mat-mini-fab class="closex" color="warn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

  <div class="card-body">
    <mat-tab-group animationDuration="0ms" [disabled]="loading">
      <mat-tab label="Role Notifications">
        <rsf-settings-role-notifications
          [rsfSettings]="rsfSettings"
          (changed)="saveChanges($event, rsfSettingsType.Notifications)"
        ></rsf-settings-role-notifications>
      </mat-tab>
      <mat-tab label="Locations Dropdowns">
        <rsf-settings-resource-types
          [rsfSettings]="rsfSettings"
          (changed)="saveChanges($event, rsfSettingsType.ResourceTypes)"
        ></rsf-settings-resource-types>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="card-footer">
    <div mat-dialog-actions align="center">
      <button
        mat-flat-button
        color="primary"
        (click)="save()"
        [disabled]="!isFormDirty()"
      >
        Save
      </button>
    </div>
  </div>
</div>
